/**
 * Build-time configuration for the browser bundle.
 *
 * ⚠️ **This file exists because `src/data/plans.ts` cannot hold it.** The Worker imports
 * `plans.ts` (see `worker/knowledge.ts`, which grounds the assistant in the real tiers), and a
 * Worker gets no Vite env injection — `import.meta.env` is simply absent there. A top-level
 * `import.meta.env.X` read in a module the Worker imports is evaluated the moment that module
 * loads, so it would not merely fail to resolve: it would **throw at Worker startup**, taking
 * `/api/chat` and `/api/audit-request` down with it. `tsc -p worker/tsconfig.json` caught it as
 * a type error, which is a narrower complaint than the actual hazard.
 *
 * The rule this encodes: anything read from `import.meta.env` belongs in a module the Worker
 * never imports. Keep that boundary rather than reaching for a `vite/client` reference, which
 * would silence the type error and leave the crash.
 */

/**
 * Where the local sandbox lives — `my.dedupr.cloud/#/local`, the PWA's own route, which is
 * exempt from the sign-in gate precisely so this link works for someone with no account.
 * Overridable so a staging tester is not sent into production.
 *
 * One owner, because three surfaces link to it: the Modes card, the pricing cards, and the
 * `#/pricing` page's local-mode section. Two of those were still opening a lead-capture modal
 * after the first was fixed, which is how a marketing page ends up asking for an email address
 * to reach the one thing that needs no account at all.
 */
export const PWA_URL = import.meta.env.VITE_PWA_URL ?? 'https://my.dedupr.cloud/#/local';
